import { ConnectionStatus } from '../../catalog/enums';
import type { IntegrationConnection } from './types';

/**
 * The connection list order: connected first, then everything else, each bucket
 * alphabetical by name (`localeCompare`). Ported from the Ember overview
 * controller's `sortByStatusAndName`.
 */
export function sortByStatusAndName(a: IntegrationConnection, b: IntegrationConnection): number {
  const statusOrder = (c: IntegrationConnection) => (c.status === ConnectionStatus.connected ? -1 : 1);
  const statusA = statusOrder(a);
  const statusB = statusOrder(b);
  if (statusA < statusB) {
    return -1;
  }
  if (statusA > statusB) {
    return 1;
  }
  return a.name.localeCompare(b.name);
}
